import styled from "@emotion/styled";
import { DESKTOP, device } from "@/themes/device";
import {
  grayScale,
  mBody1,
  mBody2,
  mBody3,
  mCaption1,
  mHeader1,
  mTitle2,
  wArticle2,
  wBody2,
  wHeader2,
  wTitle2,
} from "@teamsparta/design-system";

export const Wrapper = styled.section``;
export const Top = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 328px;
  gap: 20px;
  margin: 0 auto 40px auto;
  @media ${device.desktop} {
    width: 100%;
    max-width: 1152px;
    align-items: center;
    gap: 30px;
    margin-bottom: 80px;
  }
`;
export const Title = styled.h1`
  ${mHeader1};
  text-align: left;
  br {
    display: none;
    &.mkt {
      display: initial;
    }
  }
  ${DESKTOP} {
    ${wHeader2};
    text-align: center;
    br {
      display: initial;
    }
  }
`;

export const Desc = styled.p`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 170%;
  color: rgba(0, 0, 0, 0.72) !important;
  width: 328px;
  ${DESKTOP} {
    ${wArticle2};
    width: 519px;

    text-align: center;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  height: 515px;
  margin-top: 20px;
  padding-right: 26px; // 캐러셀 오른쪽 끝까지 스크롤했을 때 있어야 하는 여백
  overflow-x: scroll;
  transform-style: preserve-3d;
  scroll-snap-type: x mandatory;
  transition: left 1s;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (min-width: 450px) {
    margin: 0 auto;
    width: 328px;
  }
  @media (max-width: 450px) {
    margin: 0 0 0 26px;
  }

  @media ${device.desktop} {
    width: 1040px;
    display: flex;
    align-items: center;
    padding: 0px;
    gap: 40px;
    //margin: 20px auto 0 auto;
    //margin: 0 auto;
  }
`;

export const Slide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: 320px;
  height: 511px;

  ${DESKTOP} {
    width: 320px;
    height: 511px;

    min-width: initial;
    @media (max-width: 1152px) {
      width: 300px;
      height: 360px;
    }
  }
`;

export const Profile = styled.div`
  width: 320px;
  height: 205px;

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 30px 24px 26px 24px;
  position: relative;
  background: #e4ebf0;
`;
export const Name = styled.div`
  ${mTitle2};
  margin-bottom: 6px;
  color: #3a3e41;
`;

export const Specialty = styled.span`
  ${mBody3};
  height: 20px;
  text-align: justify;
  color: #5f666b;
  margin-bottom: 7px;
  color: #5f666b;
`;
export const Career = styled.div`
  height: 102px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  white-space: pre-wrap;
  p {
    ${mCaption1};
    color: #81898f;
  }
`;
export const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 24px;
  gap: 12px;
  width: 320px;
  height: 306px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #222526;
`;

export const MessageTitle = styled.h6`
  ${mTitle2};
  color: ${grayScale.gray0};
  margin: 0px;
  white-space: pre-wrap;
  line-height: 160%;
`;

export const ProjectDescription = styled.p`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 170%;

  color: #b4bfc6;
`;

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
`;
